import React, { useState, useEffect } from 'react';
import { Menu, X, Phone } from 'lucide-react';
import Logo from './Logo';
import { contactInfo } from '../data/mock';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { label: 'Services', href: '#services' },
    { label: 'Portfolio', href: '#portfolio' },
    { label: 'About', href: '#about' },
    { label: 'Areas', href: '#areas' },
    { label: 'Reviews', href: '#reviews' },
    { label: 'Contact', href: '#contact' }
  ];

  const scrollToSection = (e, href) => {
    e.preventDefault();
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
    setIsMobileMenuOpen(false);
  };

  return (
    <header 
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled 
          ? 'bg-white/95 backdrop-blur-md shadow-sm' 
          : 'bg-transparent'
      }`}
    >
      <div className="container">
        <div className="flex items-center justify-between h-20">
          {/* Logo - Icon on mobile, full on desktop */}
          <a href="#" onClick={(e) => scrollToSection(e, '#hero')}>
            <div className="md:hidden">
              <Logo variant="icon" />
            </div>
            <div className="hidden md:block">
              <Logo variant="full" />
            </div>
          </a>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center gap-8">
            {navLinks.map((link) => (
              <a
                key={link.label}
                href={link.href}
                onClick={(e) => scrollToSection(e, link.href)}
                className="text-sm font-medium transition-colors hover:text-[var(--accent-blue)]"
                style={{ color: 'var(--text-secondary)' }}
              >
                {link.label}
              </a>
            ))}
          </nav>

          {/* CTA Buttons */}
          <div className="flex items-center gap-3">
            <a 
              href={`tel:${contactInfo.phone.replace(/[^0-9]/g, '')}`}
              className="hidden sm:flex items-center gap-2 text-sm font-medium transition-colors hover:text-[var(--accent-blue)]"
              style={{ color: 'var(--text-primary)' }}
            >
              <Phone size={16} />
              <span className="hidden md:inline">{contactInfo.phone}</span>
            </a>
            <a 
              href="#contact"
              onClick={(e) => scrollToSection(e, '#contact')}
              className="btn-primary text-sm py-2 px-4 md:py-3 md:px-6"
            >
              Get Quote
            </a>
            
            {/* Mobile Menu Button */}
            <button 
              className="lg:hidden p-2 rounded-lg hover:bg-gray-100 transition-colors"
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              aria-label="Toggle menu"
            >
              {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Menu */}
      <div 
        className={`lg:hidden absolute top-full left-0 right-0 bg-white shadow-lg transition-all duration-300 ${
          isMobileMenuOpen ? 'opacity-100 visible' : 'opacity-0 invisible'
        }`}
      >
        <nav className="container py-4">
          {navLinks.map((link) => (
            <a
              key={link.label}
              href={link.href}
              onClick={(e) => scrollToSection(e, link.href)}
              className="block py-3 text-base font-medium border-b border-gray-100 transition-colors hover:text-[var(--accent-blue)]"
              style={{ color: 'var(--text-primary)' }}
            >
              {link.label}
            </a>
          ))}
          <a 
            href={`tel:${contactInfo.phone.replace(/[^0-9]/g, '')}`}
            className="flex items-center gap-2 py-3 text-base font-medium"
            style={{ color: 'var(--accent-blue)' }}
          >
            <Phone size={18} />
            {contactInfo.phone}
          </a>
        </nav>
      </div>
    </header>
  );
};

export default Header;
